var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.smallImageUrls.length
      ? _c(
          "div",
          { style: _vm.style, attrs: { id: "bundle-viewer" } },
          [
            _c(
              "v-stage",
              {
                ref: "stage",
                attrs: { config: _vm.stageConfig },
                on: { mousemove: _vm.stageMouseMoveHandler },
                nativeOn: {
                  scroll: function($event) {
                    return _vm.zoom.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "v-layer",
                  [
                    _c(
                      "v-group",
                      {
                        ref: "bundleGroup",
                        attrs: {
                          config: _vm.groupConfig,
                          dragBoundFunc: _vm.dragBoundsHandler
                        },
                        on: {
                          dragstart: _vm.dragStartHandler,
                          dragend: _vm.dragEndHandler
                        }
                      },
                      _vm._l(_vm.images, function(imageConf, key) {
                        return imageConf.image && !_vm.loading
                          ? _c("v-image", {
                              key: key,
                              attrs: {
                                dragBoundFunc: _vm.dragBoundsHandler,
                                config: imageConf
                              },
                              on: {
                                mouseover: function($event) {
                                  return _vm.setHoverIndex(key)
                                },
                                mouseleave: function($event) {
                                  return _vm.setHoverIndex(null)
                                },
                                click: function($event) {
                                  return _vm.$emit(
                                    "clicked-bundle",
                                    _vm.bundles[key]
                                  )
                                },
                                dblclick: function($event) {
                                  return _vm.$emit(
                                    "dblclicked-bundle",
                                    _vm.bundles[key]
                                  )
                                }
                              }
                            })
                          : _vm._e()
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _vm.scala
                      ? _c("v-shape", {
                          ref: "scala",
                          attrs: { config: _vm.scalaConfig }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.loadingImages
              ? _c(
                  "progress",
                  {
                    attrs: {
                      id: "image-load-progress",
                      max: _vm.smallBundleImages.length
                    },
                    domProps: { value: _vm.largeBundleImages.length }
                  },
                  [_vm._v("Lade Bilder...")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.supportsFullscreen
              ? _c("q-btn", {
                  staticClass: "canvas-overlay-button",
                  attrs: {
                    id: "fullscreen-toggle",
                    icon: "fullscreen",
                    color: "primary",
                    dense: ""
                  },
                  on: { click: _vm.toggleFullscreen }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.zoomable
              ? _c("q-btn", {
                  staticClass: "canvas-overlay-button",
                  attrs: {
                    id: "scale-dec",
                    icon: "remove",
                    color: "primary",
                    dense: ""
                  },
                  on: { click: _vm.decreaseScale }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.zoomable
              ? _c("q-btn", {
                  staticClass: "canvas-overlay-button",
                  attrs: {
                    id: "scale-inc",
                    icon: "add",
                    color: "primary",
                    dense: ""
                  },
                  on: { click: _vm.increaseScale }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.bundles
              ? _c(
                  "floating-info-box",
                  {
                    ref: "tooltip",
                    attrs: {
                      open: _vm.bundles[_vm.hoverIndex] !== undefined,
                      conf: _vm.tooltipConf
                    }
                  },
                  [
                    _c("BundleInfo", {
                      attrs: { bundle: _vm.bundles[_vm.hoverIndex] }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }